/**
 * 自定义指令添加
 */
import type { App } from 'vue'
import { numberToCurrencyNo } from '@/utils'
export default {
  install(app: App) {
    /** 千位分隔符 */
    app.directive('separator', {
      updated(el, binding: { value: string }) {
        el.innerHTML = numberToCurrencyNo(Number(binding.value))
      },
      mounted(el, binding: { value: string }) {
        el.innerHTML = numberToCurrencyNo(Number(binding.value))
      }
    })
  }
}
